import type { RequestHandler } from 'msw';
import { mockBindSearchTag } from './bindSearchTag';
import { mockFetchPurchaseExtraSuggestedTruckers } from './fetchPurchaseExtraSuggestedTruckers';
import { refundable } from './refundable';
import { mockSearchTrucker } from './searchTrucker';
import { svgs } from './svgs';
import { mockTracking } from './tracking';
import { trucker } from './trucker';
import { mockUserMe } from './user';
import { truckerRecommended } from './truckerRecommended';
import { featureFlag } from './featureFlagr';

const handlers = [
  ...trucker,
  ...truckerRecommended,
  ...refundable,
  ...mockBindSearchTag,
  ...mockTracking,
  ...mockUserMe,
  ...mockSearchTrucker,
  ...mockFetchPurchaseExtraSuggestedTruckers,
  ...svgs,
  ...featureFlag,
];
const testHandlers: RequestHandler[] = [...handlers];

export { handlers, testHandlers };
